import { render } from "./notification_filters.vue?vue&type=template&id=70a8eb10"
import script from "./notification_filters.vue?vue&type=script&lang=js"
export * from "./notification_filters.vue?vue&type=script&lang=js"

import "./notification_filters.vue?vue&type=style&index=0&id=70a8eb10&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__